// extracted by mini-css-extract-plugin
export var companies = "introBanner-module--companies--e167c";
export var companiesGroup = "introBanner-module--companiesGroup--57e75";
export var companiesLogos = "introBanner-module--companiesLogos--6bbc0";
export var company = "introBanner-module--company--21ea1";
export var companyLink = "introBanner-module--companyLink--89240";
export var companyLogo = "introBanner-module--companyLogo--780f2";
export var image = "introBanner-module--image--d2915";
export var intro = "introBanner-module--intro--92ceb";
export var section = "introBanner-module--section--b5db0";
export var title = "introBanner-module--title--c8f80";